import {
	Row,
	Col, Container,
} from "reactstrap";
import NotificationAlert from "react-notification-alert";
import React, {useRef} from "react";

import {MotionCard} from "../../components/Core/MotionStrap";
import LoginFragment from "../../components/Core/LoginFragment";

const securityGroups = [
	"SYSTEM_MANAGER",
	"INTERNAL_MANAGER",
	"INTERNAL",
	"PRODUCT_MANAGER",
	"SUPPLIER_MANAGER",
	"COMMERCIAL_MANAGER",
	"ACCOUNTANT_MANAGER",
	"CUSTOMER_SERVICE"
]

const Login = (props) =>
{
	const notifyRef = useRef();
	const forgotPassCode = props.match.params.code;

	return (
		<>
			<NotificationAlert ref={notifyRef}/>
			<Row className="mb-5">
				<Col className="header py-7 py-lg-8">
					<Container>
						<div className="header-body text-center mb-7">
							<Row className="justify-content-center">
								<Col lg="12" md="10">
									<h1 className="text-black-50">Welcome to Ncentiva Management Platform!</h1>
								</Col>
							</Row>
						</div>
					</Container>
				</Col>
			</Row>
			<Row className="justify-content-center">
				<Col lg="5" md="7">
					<MotionCard initial={{scale: 0.2, opacity: 0.3, rotateZ: 75}} animate={{scale: 1, opacity: 1, rotateZ: 0, transition: {type: "spring"}}} className="bg-light shadow border-0 overflow-hidden">
						<LoginFragment notifyArea={notifyRef} destination={"/admin/dashboard"} securityGroup={securityGroups} setAuthData={props.setAuthData} forgotPassCode={forgotPassCode}/>
					</MotionCard>
				</Col>
			</Row>
		</>
	);
};

export default Login;
